<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>

        <v-list-item link :to="{ name: 'dashboard' }" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard-variant-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Dashboard') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'patients' }" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-account-details</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Patients') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'stock', params: {location: 'pharmacy' }}" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-playlist-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Pharmacy') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'stock', params: {location: 'local' }}" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-playlist-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Pharmacy FTS') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Reports -->
        <v-list-group
            sub-group
        >
            <template v-slot:activator>
                <v-list-item-title>{{ $t('Reports') }}</v-list-item-title>
            </template>

            <v-list-item link :to="{ name: 'report-milk-project-list' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-bottle-soda</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Milk project LIST') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-milk-project-monthly' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-bottle-soda</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Milk project monthly stats') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-speech-therapy-prep' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account-voice</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Speech therapy prep') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-speech-therapy-stats' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account-voice</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Speech therapy stats') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-psychology-prep' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-brain</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Psychology prep') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-tess-statistics' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-clipboard-list-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Statistics TESS') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-surgery' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-medical-bag</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Surgeries') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-dental' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-tooth-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Dental') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-medical-checkup' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-list-status</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Medical check-up program') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-evaluation' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-chart-histogram</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Evaluation') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'report-total-export' }" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-earth</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Total export') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>


        </v-list-group>

        <!-- /Reports -->

        <!-- Master files -->
        <v-list-group
            v-if="hasRole('admin')"
            sub-group
        >
            <template v-slot:activator>
                <v-list-item-title>{{ $t('Master files') }}</v-list-item-title>
            </template>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'program' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-form-dropdown</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Programs') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'province' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-form-dropdown</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Provinces') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'promoter' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Promoters') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'appointments_where' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Appointment locations') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'social_economic_situation' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Social-economic situations') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'type_of_lip' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Lip types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'type_of_palate' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Palate types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'revision_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Revision types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'main_status' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Patient statuses') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'module_status' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Patient module status') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'type_of_surgery' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-office-building-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Surgery types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'milk_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-bottle-soda</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Milk types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'speech_therapist' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Speech therapists') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'psychologist' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Psychologists') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'avd_category' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('AVD categories') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'dentist' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Dentists') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'syndrome' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Syndromes') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'hospital' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Hospitals') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'medical_team' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Medical teams') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'surgeon' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Surgeons') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'bottle_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-bottle-soda</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Bottle types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'pump_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Pump types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'nutrition_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-food-apple</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Nutrition types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'tape_type' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-tape-measure</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Tape types') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="{ name: 'master-files', params: {masterFileTypeTag: 'treatment_interaction' }}" @click="drawer = false">
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Treatment interactions') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

        </v-list-group>
        <!-- /Master files -->


        <!-- System -->
        <v-list-group
          v-if="hasRole('admin')"
            sub-group
        >
            <template v-slot:activator>
                <v-list-item-title>{{ $t('System') }}</v-list-item-title>
            </template>

            <v-list-item              
              link
              :to="{ name: 'users' }"
              @click="drawer = false"
            >
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Users') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="{ name: 'setting' }"
              @click="drawer = false"
            >
                <v-list-item-action>
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Settings') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="{ name: 'translation' }"
              @click="drawer = false"
            >
                <v-list-item-action>
                    <v-icon>mdi-translate</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('Translations') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="{ name: 'user-log' }"
              @click="drawer = false"
            >
                <v-list-item-action>
                    <v-icon>mdi-account-search</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('User Logging') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

        </v-list-group>
        <!-- /System -->

        <v-list-item link :to="{ name: 'logout' }" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
    >

      <v-app-bar-nav-icon
        v-if="isLoggedIn"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <router-link :to="{ name: backlink }" v-if="backlink">
        <div class="mdi mdi-arrow-left mx-4"></div>
      </router-link>

      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <SwitchLanguage/>

      <v-spacer></v-spacer>
        <router-link :to="{ name: 'dashboard' }">
          <img src="/logo.png" />
        </router-link>

    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <loading :active="!!isLoading"
        :can-cancel="true"
        :on-cancel="cancelLoading"
        color="#0097d9"
        background-color="#222222"
        :is-full-page="true"
        loader="dots"
        :width="64"
        :height="64"
    ></loading>

    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
      <v-spacer></v-spacer>
      <span>{{ user.full_name || '' }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SwitchLanguage from '@/components/SwitchLanguage.vue'

export default {
  name: 'App',
  components: {
    Loading,
    SwitchLanguage,
  },
  data: () => ({
    drawer: false,
  }),
  watch: {
      title: function() {
          document.title = this.title ?? ''
      }
  },
  computed: {
    ...mapGetters('auth', {
      isLoggedIn: 'isLoggedIn',
      hasRole: 'hasRole',
    }),
    ...mapState('session', ['isLoading', 'title', 'backlink', 'fullHeight']),
    ...mapState('auth', ['user']),
  },
  methods: {
    cancelLoading(mouseEvent) {
      if (mouseEvent === undefined) {
        this.$store.dispatch('session/hideLoader', true)
      }
    }
  },
  created() {
    if (this.$store.getters['auth/isLoggedIn']) {      
      this.$store.dispatch('language/fetch')
    }
    //this.$vuetify.theme.dark = true
    //this.$vuetify.theme.light = true
  },
}
</script>


<style>
.clickable table tbody tr:hover {
  cursor: pointer !important;
}
a .mdi {
    color: rgba(0, 0, 0, 0.87);
}
</style>
